export interface Testimonial {
  id: number;
  name: string;
  company: string;
  text: string;
  location: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Sarah Johnson",
    company: "Nottingham Retail Solutions",
    text: "Consiliuma transformed our outdated website into a modern, user-friendly platform that perfectly represents our brand. Their full-stack development expertise ensured everything from design to functionality exceeded our expectations. The SEO optimization has significantly improved our visibility in Nottingham.",
    location: "Nottingham, UK"
  },
  {
    id: 2,
    name: "Michael Rodriguez",
    company: "Desert Valley Tech",
    text: "Working with Consiliuma across international time zones was seamless. Their British team's attention to detail and technical prowess delivered a sophisticated web application that has streamlined our operations. Their maintenance service gives us peace of mind knowing our site is always secure and up-to-date.",
    location: "Phoenix, Arizona"
  },
  {
    id: 3,
    name: "Liam Chen",
    company: "Singapore Business Solutions",
    text: "After disappointing experiences with other agencies, finding Consiliuma was a breath of fresh air. Their understanding of both Western and Asian markets helped us create a website that appeals to our diverse client base. The website has already generated a significant ROI in just three months.",
    location: "Singapore, SE Asia"
  },
  {
    id: 4,
    name: "Emma Wilson",
    company: "Midlands Healthcare Group",
    text: "Consiliuma designed and built our patient portal with exceptional care and professionalism. They understood the complex requirements of healthcare websites, including accessibility and data security. Their ongoing support has been outstanding, with quick responses to any questions or updates needed.",
    location: "Nottingham, UK"
  }
];